import axios from 'services/network/axios';

//  *** GetSteps
export const GetOrderSteps = () => axios.get('Order/GetOrderSteps');

//  *** GetPaymentTypes
export const GetPaymentTypes = () => axios.get('Order/GetPaymentTypes');

//  *** GetBills
export const GetBills = (filter) => axios.post('Order/GetBills', filter);

//  *** GetBillDetail
export const GetBillDetail = (id) => axios.get(`Order/GetBillDetail?id=${id}`);

//  *** Update
export const Update = (data) => axios.post(`Order/Update`, data);
